import(/* webpackMode: "eager" */ "/vercel/path1/app/(public)/(marketing)/about/page.js");
